import { ChangeSource, RenderAdapter } from '../adapters/types';
import { useChangeVersion } from '../adapters/useChangeVersion';
import { formatSliceIndicator, SliceIndicator } from './tileViewModel';

/**
 * Where the view sits in the image it shows, read from renderer truth, or
 * undefined before the renderer mounts. It follows the engine-owned cursor,
 * and the row's frame too, because a turn of the frame can move the plane
 * on or off the slices with no move of the cursor.
 */
export function useSliceIndicator(
    renderer: RenderAdapter,
    frameSource: ChangeSource
): SliceIndicator | undefined {
    useChangeVersion(renderer.getCursorSource());
    useChangeVersion(frameSource);
    const slice = renderer.getSliceInfo();
    return slice ? formatSliceIndicator(slice) : undefined;
}
